import { useCallback } from 'react';
import { useKeycloak } from '@react-keycloak/web';

export function useAuth() {
  const { keycloak, initialized } = useKeycloak();

  const isAuthenticated = !!keycloak?.authenticated;

  const getToken = useCallback((): string | undefined => {
    return keycloak?.token;
  }, [keycloak]);

  const logout = useCallback(() => {
    keycloak?.logout();
  }, [keycloak]);

  const hasRole = useCallback(
    (role: string) => {
      return keycloak?.hasRealmRole(role) ?? false;
    },
    [keycloak]
  );

  return {
    initialized,
    isAuthenticated,
    getToken,
    logout,
    hasRole,
    user: keycloak?.tokenParsed,
  };
}
